import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../../../../../../../emotion-theme";
import { FlyerDetailPagePreviewCellProps } from "./flyer-detail-page-preview-cell.props";

export const FlyerDetailPageDetailPositionCell = styled.div`
  grid-column-start: ${(props: FlyerDetailPagePreviewCellProps) => props.columnSpan.min + 1};
  grid-column-end: ${(props: FlyerDetailPagePreviewCellProps) => props.columnSpan.max + 2};
  grid-row-start: ${(props: FlyerDetailPagePreviewCellProps) => props.rowSpan.min + 1};
  grid-row-end: ${(props: FlyerDetailPagePreviewCellProps) => props.rowSpan.max + 2};

  background-color: ${BASE_COLORS.lightGrey};
  border: solid 1px ${BASE_COLORS.lightGrey};

  height: 100%;

  :hover,
  &.active {
    border: solid 4px ${BASE_COLORS.paleBlue};
    background-color: ${BASE_COLORS.lightPaleBlue};
  }

  :hover {
    cursor: pointer;
  }
`;
